export enum TrackingEventTypes {
  //Entry
  ResetSessionManually = "reset_session_manually",
  ResetSessionAutomatically = "reset_session_automatically",
  PrimaryAttributesDrawerOpen = "primary_attributes_drawer_open",
  LanguageAndCurrencyModalOpen = "language_and_currency_modal_open",
  LanguageAndCurrencyModalClose = "language_and_currency_modal_close",
  SignUpModalOpen = "sign_up_modal_open",
  SignUpConfirm = "sign_up_confirm",
  SignUpConfirmSuccess = "sign_up_confirm_success",
  SignUpConfirmFailed = "sign_up_confirm_failed",

  //Scanner
  ConnectedScannerDetected = "connected_scanner_detected",
  ScannerConnected = "scanner_connected",
  ScannerDisconnected = "scanner_disconnected",
  ScannerInHIDMode = "scanner_in_hid_mode",
  BarCodeScanSuccess = "bar_code_scan_success",
  BarCodeScanFailed = "bar_code_scan_failed",

  //Preference
  SearchDrawerOpen = "search_drawer_open",
  SearchDrawerClose = "search_drawer_close",
  SearchTermAdded = "search_term_added",
  SearchTermRemoved = "search_term_removed",
  StaffPageOpened = "staff_page_opened",
  StaffPortalOpened = "staff_portal_opened",
  StylesSearch = "styles_search",
  LanguageChanged = "language_changed",
  CountryChanged = "country_changed",
  StaffPasscodePageOpened = "staff_passcode_page_opened",
  InvalidPasscodeEntered = "invalid_passcode_entered",
  ValidPasscodeEntered = "valid_passcode_entered",

  // Product listing
  ProductDetailsOpen = "product_details_open",
  SelectSize = "select_size",
  SelectLength = "select_length",
  SelectColorVariant = "select_color_variant",
  ProductDescriptionOpened = "product_description_opened",
  MaterialCompositionOpened = "material_composition_opened",
  TapToEnlargeMedia = "tap_to_enlarge_media",
  SelectColorVariantFromSimilarStyles = "select_color_variant_from_similar_styles",
  SelectColorVariantFromCompleteLook = "select_color_variant_from_complete_look",
  SelectColorVariantFromShopLook = "select_color_variant_from_shop_look",
  SelectColorVariantFromHowAboutThese = "select_color_variant_from_how_about_these",
  SelectColorVariantFromCollection = "select_color_variant_from_collection",
  SelectColorVariantFromAllColors = "select_color_variant_from_all_colors",
  SelectColorVariantFromAllItems = "select_color_variant_from_all_items",
  SelectColorVariantFromHTWI = "select_color_variant_from_how_to_wear_it",
  ViewMoreFromSimilarStylesClick = "view_more_from_similar_styles_click",
  ViewMoreFromCompleteLookClick = "view_more_from_complete_look_click",
  ViewMoreFromShopLookClick = "view_more_from_shop_look_click",
  ViewMoreFromHowAboutTheseClick = "view_more_from_how_about_these_click",
  ViewMoreFromCollectionClick = "view_more_from_collection_click",
  ViewMoreFromAllColorsClick = "view_more_from_all_colors_click",
  ViewMoreFromAllItemsClick = "view_more_from_all_items_click",
  SelectOutOfStock = "select_out_of_stock",
  OpenAllColorsWidget = "open_all_colors_widget",
  AddToCollectionModalOpened = "add_to_collection_modal_opened",
  AddedToCollectionFromPDP = "added_to_collection_from_pdp",

  // Basket
  BasketQuantityChanged = "basket_quantity_changed",
  FailedAddingToBasketDueToStockLimit = "failed_adding_to_basket_due_to_stock_limit",
  BasketOpen = "basket_open",
  BasketExit = "basket_exit",
  BasketConfirm = "basket_confirm",
  QuickAddToBasketOpen = "quick_add_to_basket_open",
  ParkBasketModalOpen = "park_basket_modal_open",
  ParkBasket = "park_basket",
  RestoreParkedBasket = "restore_parked_basket",

  // Checkout
  CheckoutOpen = "checkout_open",
  CheckoutExit = "checkout_exit",
  CheckoutInputValidationError = "checkout_input_validation_error",
  CheckoutConfirm = "checkout_confirm",
  CheckoutFormUsed = "checkout_form_used",
  BackToBasketFromCheckoutToEdit = "back_to_basket_from_checkout_to_edit",

  // Summary
  SummaryOpen = "summary_open",
  SummaryBackToEdit = "summary_back_to_edit",
  SummaryConfirm = "summary_confirm",
  SummaryConfirmSuccess = "summary_confirm_success",
  SummaryConfirmFailed = "summary_confirm_failed",

  // Session-Segments
  SessionSegments = "session_segments",

  // Websocket
  DeviceArchived = "device_archived",
  StoreArchived = "store_archived",
  ReleaseNotification = "release_notification",
  InitializationCompleted = "initialization_completed",
  DeviceMetadata = "device_metadata",
}
